import React, { useEffect, useState } from 'react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { Spinner } from '@/components/spinner';
import { useAppContext } from '@/context/app';
import { OperatorUsageWizardStep1 } from './Step1';
import { cleanWizardData, WizardData } from './Model';
import { useWizard, WizardProvider } from '@/common/wizard/wizard';
import { UseFormReturn } from 'react-hook-form';
import { addServerErrors } from '@/components/forms/common/FormBase';
import { OperatorUsageWizardResult } from './Result';

const maxStep = 2

export const OperatorUsageWizardBody = ({ onDone }: {
  onDone: (id: string) => void
}) => {
  // const {services, session, translates} = useAppContext()
  const { step} = useWizard()

  if (step === 0) {
    return <OperatorUsageWizardStep1  />
  } else if (step === 1) {
    return <OperatorUsageWizardResult />
  } else return <Spinner />
}

export const OperatorUsageWizard = ({ onDone }: {
  onDone: (id: string) => void
}) => {
  return <div className='operatorusage-wizard'>
    <WizardProvider<WizardData> initialData={cleanWizardData()} maxStep={maxStep}>
      <OperatorUsageWizardBody onDone={onDone} />
    </WizardProvider>
  </div>
}

export const OperatorUsageWizardPopup = ({ onClose }: {
  onClose: () => void
}) => {
  return <OperatorUsageWizard onDone={onClose} />
}
